var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlikBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 20,
    viewBox: "0 0 43 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6621 3.61521e-07H2.33822C2.04069 -0.000167711 1.74604 0.0582687 1.4711 0.171973C1.19615 0.285678 0.946292 0.452423 0.735788 0.66269C0.525284 0.872957 0.358256 1.12263 0.244241 1.39744C0.130226 1.67226 0.071457 1.96684 0.0712891 2.26437V17.7359C0.071457 18.0335 0.130229 18.328 0.244247 18.6028C0.358266 18.8776 0.525299 19.1273 0.735808 19.3375C0.946316 19.5478 1.19618 19.7145 1.47112 19.8281C1.74606 19.9418 2.04071 20.0002 2.33822 20H40.6621C40.9596 20.0002 41.2542 19.9417 41.5291 19.828C41.804 19.7144 42.0538 19.5476 42.2643 19.3374C42.4748 19.1272 42.6418 18.8775 42.7558 18.6028C42.8698 18.328 42.9285 18.0334 42.9287 17.7359V2.26437C42.9284 1.66354 42.6894 1.08745 42.2643 0.662803C41.8393 0.23816 41.2629 -0.000254217 40.6621 3.61521e-07Z",
    fill: "url(#paint0_linear_15723_31729)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3648 4.49772C16.3648 5.09903 16.126 5.67572 15.7008 6.10091C15.2756 6.5261 14.6989 6.76497 14.0976 6.76497C13.4963 6.76497 12.9196 6.5261 12.4944 6.10091C12.0692 5.67572 11.8303 5.09903 11.8303 4.49772C11.8303 3.89641 12.0692 3.31972 12.4944 2.89453C12.9196 2.46934 13.4963 2.23047 14.0976 2.23047C14.6989 2.23047 15.2756 2.46934 15.7008 2.89453C16.126 3.31972 16.3648 3.89641 16.3648 4.49772Z",
    fill: "url(#paint1_linear_15723_31729)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8026 17.3388H37.0672L33.145 12.273L36.7016 7.92017H33.7406L30.2479 12.3002V2.95991H27.7129V17.3388H30.2479L30.246 12.3123L33.8026 17.3388ZM22.9315 7.91857H25.4658V17.3372H22.9315V7.91857ZM18.1481 2.95703H20.6824V17.3372H18.1481V2.95703ZM11.559 7.82452C10.7656 7.8234 9.98429 8.0195 9.2854 8.39518V2.95735H6.75073V12.6309C6.75048 13.5818 7.03221 14.5114 7.56031 15.3022C8.0884 16.093 8.83913 16.7094 9.71756 17.0735C10.596 17.4376 11.5627 17.533 12.4953 17.3477C13.428 17.1624 14.2848 16.7047 14.9573 16.0324C15.6298 15.3602 16.0879 14.5036 16.2735 13.571C16.4592 12.6384 16.3642 11.6717 16.0004 10.7931C15.6367 9.91455 15.0206 9.16357 14.23 8.63516C13.4394 8.10676 12.5099 7.82465 11.559 7.82452ZM11.559 14.9449C11.1015 14.9449 10.6542 14.8092 10.2737 14.555C9.89323 14.3008 9.59668 13.9394 9.42156 13.5167C9.24644 13.094 9.2006 12.6288 9.28985 12.18C9.37909 11.7312 9.59941 11.3189 9.92295 10.9954C10.2465 10.6718 10.6587 10.4514 11.1075 10.3621C11.5563 10.2728 12.0214 10.3186 12.4442 10.4936C12.867 10.6687 13.2283 10.9652 13.4826 11.3456C13.7369 11.7261 13.8726 12.1733 13.8727 12.6309C13.8728 12.9348 13.8131 13.2357 13.6968 13.5165C13.5806 13.7973 13.4102 14.0524 13.1953 14.2673C12.9805 14.4822 12.7254 14.6526 12.4446 14.7689C12.1638 14.8852 11.8629 14.945 11.559 14.9449Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15723_31729",
    x1: 21.5002,
    y1: 19.9037,
    x2: 21.5002,
    y2: 0.0962815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#080808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15723_31729",
    x1: 12.4937,
    y1: 6.10156,
    x2: 15.7014,
    y2: 2.89388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E52F08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94F96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlikBlack);
export default __webpack_public_path__ + "static/media/blik-black.4de698a6.svg";
export { ForwardRef as ReactComponent };